import { FC, useState, useRef } from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import CustomerList from '../../../Customer/CustomerList';
import DrawerMenu from 'components/DrawerMenu';
import strings from 'common/Translation/Translate';
import AddEditCustomer from '../../../Customer/AddEditCustomer/AddEditCustomer';

interface CustomerListWithEditModalProps {
  companyId: number;
  branchId: number;
  openDrawer: boolean;
  companyName?: string;
  setOpenDrawer: (val: boolean) => void;
  onBranchRefresh?: () => void;
  branchData?: {
    country?: number;
    state?: number;
    city?: number;
    address?: string;
    states?: any[];
    cities?: any[];
  };
}

const CustomerListWithEditModal: FC<CustomerListWithEditModalProps> = ({
  companyId,
  branchId,
  openDrawer,
  setOpenDrawer,
  companyName,
  onBranchRefresh,
  branchData,
}) => {
  const theme = useTheme();
  const screenSizeDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const [isEditDrawer, setIsEditDrawer] = useState<boolean>(false);
  const [editingCustomerId, setEditingCustomerId] = useState<number | string | null>(null);
  const refreshListRef = useRef<(() => void) | null>(null);

  const handleClose = () => {
    setOpenDrawer(false);
    setIsEditDrawer(false);
  };

  const handleEditCustomer = (rowData: any) => {
    if (rowData) {
      setEditingCustomerId(rowData.id);
      setIsEditDrawer(true);
      setOpenDrawer(true);
    }
  };

  const handleAddCustomer = () => {
    setEditingCustomerId(null);
    setIsEditDrawer(false);
    setOpenDrawer(true);
  };
  const handleSave = () => {
    handleClose();
    // Refresh the customer list after save
    if (refreshListRef.current) {
      refreshListRef.current();
    }
    // Refresh branch details to update left sidebar
    if (onBranchRefresh) {
      onBranchRefresh();
    }
  };

  return (
    <>
      <CustomerList
        companyId={companyId}
        branchId={branchId}
        customEdit={handleEditCustomer}
        customAdd={handleAddCustomer}
        onRefreshCallback={refreshFn => {
          refreshListRef.current = refreshFn;
        }}
      />
      <DrawerMenu
        width={screenSizeDownSm ? '100%' : '70%'}
        open={openDrawer}
        handleClose={handleClose}
        closeButton={true}
        title={isEditDrawer ? strings.customermgmt_title_edit : strings.customermgmt_title_add}>
        <AddEditCustomer
          handleSave={handleSave}
          companyName={companyName}
          companyId={companyId}
          branchId={branchId}
          editingCustomerId={editingCustomerId}
          branchData={branchData}
        />
      </DrawerMenu>
    </>
  );
};

export { CustomerListWithEditModal };
